export default __webpack_public_path__ + "img/img_6.1b840559.png";